import React from 'react'
import {
  getOutletTheme,
  OUTLET_THEME_DESCRIPTIONS,
} from '../../constants/outletThemes'

function OutletBlock({ compact, outletReason, expirationOption, missingExpirationOption, outletOptionId }) {
  const theme = getOutletTheme(outletReason)
  const description = OUTLET_THEME_DESCRIPTIONS[theme]
  const classNames = ['OutletBlock', `OutletBlock--${theme}`, compact && 'OutletBlock--compact']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classNames}>
      <p className="OutletBlock-title">Ame Outlet</p>
      <p className="OutletBlock-description">{description}</p>

      {theme === 'mint' && expirationOption && (
        <div className="OutletBlock-option OutletBlock-option--active">
          До {expirationOption.expirationDate || '—'}
        </div>
      )}

      {missingExpirationOption && (
        <p className="OutletBlock-error">Експірація: опцію не знайдено (id: {outletOptionId})</p>
      )}
    </div>
  )
}

export default OutletBlock
